import { render, staticRenderFns } from "./collapsible.vue?vue&type=template&id=6f80276a&scoped=true&"
import script from "./collapsible.vue?vue&type=script&lang=ts&"
export * from "./collapsible.vue?vue&type=script&lang=ts&"
import style0 from "./collapsible.vue?vue&type=style&index=0&id=6f80276a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f80276a",
  null
  
)

export default component.exports